import i18next from "i18n";
import { lazy } from "react";
import { getExactHiddenRoute, getExactRoute } from "util/react";

import EN from "./i18n/en.json";
import LT from "./i18n/lt.json";

i18next.addResourceBundle("en", "user", EN);
i18next.addResourceBundle("lt", "user", LT);

export const UserCreateRoute = getExactHiddenRoute(
  "user",
  "menu.edit",
  "/user/new",
  lazy(() => import("./layout/UserEditLayout")),
  null,
  ["admin"],
);
export const UserEditRoute = getExactHiddenRoute(
  "user",
  "menu.edit",
  "/user/:id",
  lazy(() => import("./layout/UserEditLayout")),
  null,
  ["admin", "customer"],
);
export const UserListRoute = getExactRoute(
  "user",
  "menu.list",
  "/user",
  lazy(() => import("./layout/UserListLayout")),
  null,
  ["admin"],
);
export const UserInvitedRoute = getExactHiddenRoute(
  "user",
  "menu.list",
  "/invite/:id",
  lazy(() => import("./layout/UserInviteLayout")),
  null,
  [],
);

const UserRoute = (
  <>
    {UserListRoute}
    {UserCreateRoute}
    {UserEditRoute}
    {UserInvitedRoute}
  </>
);

export default UserRoute;
